
import { defineComponent } from 'vue';

export default defineComponent({
  name: 'ImageInfo',
  props: {
    source: {
      type: String,
      required: true,
    },
    text: {
      type: String,
      required: true,
    },
  },
});
